import { render, staticRenderFns } from "./CompteurDemandeBadge.vue?vue&type=template&id=169c8ac8&"
import script from "./CompteurDemandeBadge.vue?vue&type=script&lang=js&"
export * from "./CompteurDemandeBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
